module.exports = __webpack_public_path__ + "img/ic-announcement-inactive.49eb14c9.svg";